import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  // addPromoKaos,
  removeCartItem
} from "features/common/layouts/cartSlice";
import { useLocation } from "react-router-dom";
import { useQuery, formatIDR } from "helpers/utils";
import { notifyWarning } from "components/ToastMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';

const PromoKaosTumbler = ({ price, billingcycle }) => {
  const dispatch = useDispatch();
  const { productsList, existingDomain } = useSelector((state) => state.cart);

  // Get domain from register/transfer in cart for auto-fill
  const getDomainFromCart = () => {
    const registerDomain = productsList.find(item => item.type === "register");
    const transferDomain = productsList.find(item => item.type === "transfer");
    const existingDomainFromCart = productsList.find(item => item.type === "domain-existing");

    if (registerDomain && registerDomain.domain) {
      return registerDomain.domain;
    } else if (transferDomain && transferDomain.domain) {
      return transferDomain.domain;
    } else if (existingDomainFromCart && existingDomainFromCart.domain) {
      return existingDomainFromCart.domain;
    } else if (existingDomain && existingDomain.domain) {
      return existingDomain.domain;
    }

    return null;
  };

  const cartDomain = getDomainFromCart();
  // const isEligibleForPromo = price >= 3000000;
  // const [promoKaosTumbler, setPromoKaosTumbler] = useState(false);
  const [maintenancePrice, setMaintenancePrice] = useState(0);
  const [oriMaintenancePrice, setOriMaintenancePrice] = useState(0);
  const [sslPremiumPrice, setSslPremiumPrice] = useState(0);
  const [oriSslPremiumPrice, setOriSslPremiumPrice] = useState(0);
  const [emailTitanProPrice, setEmailTitanProPrice] = useState(0);
  const [oriEmailTitanProPrice, setOriEmailTitanProPrice] = useState(0);
  const [monitimePrice, setMonitimePrice] = useState(0);
  const [oriMonitimePrice, setOriMonitimePrice] = useState(0);
  const [products, setProducts] = useState([]);
  const [emailAccountValue, setEmailAccountValue] = useState(0);
  const [monitimeQuantity, setMonitimeQuantity] = useState(1);
  const [isProductsLoading, setIsProductsLoading] = useState(true);
  const [productsError, setProductsError] = useState(null);
  const isInitialized = useRef(false);
  const query = useQuery();
  const isOrderEmailSuitePage =
    useLocation().pathname === "/orderemailsuite";
  const isJasaMaintenanceWebsite =
    useLocation().pathname === "/orderhosting" && query.pid === "1110";
  const isOrderProductMonitime =
    useLocation().pathname === "/orderproduct" && query.pid === "1157";
  const [selectedMaintenanceCycle, setSelectedMaintenanceCycle] = useState(billingcycle);
  const [selectedMonitimeCycle, setSelectedMonitimeCycle] = useState(billingcycle);
  const [selectedEmailCycle, setSelectedEmailCycle] = useState("annually");
  const [isMaintenanceChecked, setIsMaintenanceChecked] = useState(false);
  const [isMonitimeChecked, setIsMonitimeChecked] = useState(false);
  const [isEmailTitanChecked, setIsEmailTitanChecked] = useState(false);
  const [showOtherProducts, setShowOtherProducts] = useState(false);
  const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);

  const openMaintenanceModal = () => {
    setShowMaintenanceModal(true);
  };

  const closeMaintenanceModal = () => {
    setShowMaintenanceModal(false);
  };

  useEffect(() => {
    async function fetchProduct(pid, billingcycle) {
      const url = `${process.env.REACT_APP_BASE_API}order/apis/getProducts.php?pid=${pid}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        const product = data.products.product[0];
        const {
          pid,
          gid,
          name,
          type,
          customfields: { customfield: customfieldvalue },
          configoptions,
          pricing: { IDR: pricingIDR }
        } = product;

        return {
          pid,
          gid,
          customfieldvalue,
          name,
          type,
          configoptions,
          pricing: pricingIDR,
          billingcycle
        };
      } catch (error) {
        console.error("Error fetching product:", error);
        return null;
      }
    }

    async function fetchProducts() {
      // Only fetch if not initialized
      if (!isInitialized.current) {
        setIsProductsLoading(true);
        setProductsError(null);

        try {
          const product1110 = await fetchProduct("1110", billingcycle); // Maintenance
          const product1157 = await fetchProduct("1157", billingcycle); // Monitime Trial
          const product1237 = await fetchProduct("1237", billingcycle);
          const product924 = await fetchProduct("924", billingcycle);

          // Check if any product failed to load
          const failedProducts = [product1110, product1157, product1237, product924].filter(product => product === null);

          if (failedProducts.length > 0) {
            setProductsError(`Gagal memuat ${failedProducts.length} produk. Silakan refresh halaman.`);
            console.error("Some products failed to load:", failedProducts);
          }

          // Array order: [Maintenance, Monitime Trial, SSL, Email]
          // products[0] = Maintenance (PID 1110)
          // products[1] = Monitime Trial (PID 1157)
          // products[2] = SSL (PID 1237)
          // products[3] = Email (PID 924)
          setProducts([product1110, product1157, product1237, product924]);
          isInitialized.current = true;
        } catch (error) {
          console.error("Error fetching products:", error);
          setProductsError("Gagal memuat produk. Silakan refresh halaman.");
        } finally {
          setIsProductsLoading(false);
        }
      }
    }

    fetchProducts();
  }, [billingcycle]);

  useEffect(() => {
    const maintenanceProduct = products[0];
    if (maintenanceProduct) {
      const basePrice = parseFloat(maintenanceProduct.pricing[billingcycle]) || 0;
      setMaintenancePrice(basePrice * 1.2);
      setOriMaintenancePrice(basePrice);
    }

    const monitimeProduct = products[1];
    if (monitimeProduct) {
      // Monitime Trial selalu gratis (harga 0)
      setMonitimePrice(0);
      setOriMonitimePrice(0);
    }

    const sslProduct = products[2];
    if (sslProduct) {
      // Promo khusus: TuringSign Basic DV (PID 1237) Rp100.000 (coret) -> Rp65.000
      if (Number(sslProduct.pid) === 1237) {
        setOriSslPremiumPrice(100000);
        setSslPremiumPrice(65000);
      } else {
        // Fallback: gunakan pricing annually dari produk yang ter-load
        const originalPrice = parseFloat(sslProduct?.pricing?.annually) || 0;
        if (originalPrice > 0) {
          const discountSsl = originalPrice - 40000;
          setSslPremiumPrice(Math.max(0, discountSsl)); // Pastikan tidak negatif
          setOriSslPremiumPrice(originalPrice);
        } else {
          setSslPremiumPrice(0);
          setOriSslPremiumPrice(0);
        }
      }
    }

    const emailProduct = products[3];
    if (emailProduct && emailProduct.configoptions?.configoption[0]?.options?.option[0]?.pricing?.IDR) {
      const pricingIDR = emailProduct.configoptions.configoption[0].options.option[0].pricing.IDR;

      // Ambil harga sesuai selectedEmailCycle (tidak terpengaruh billing cycle utama)
      const basePrice = parseFloat(pricingIDR[selectedEmailCycle]) || 0;
      setEmailTitanProPrice(basePrice); // Harga setelah diskon
      setOriEmailTitanProPrice(basePrice * 1.1); // Harga original + 10%
    }
  }, [products, billingcycle, selectedEmailCycle]);

  const changeMaintenanceCheckbox = (e) => {
    const maintenanceProduct = products[0];
    const isChecked = e.target.checked;
    setIsMaintenanceChecked(isChecked);

    if (isChecked && maintenancePrice > 0) {
      dispatch(
        addToCart({
          gid: maintenanceProduct.gid,
          pid: maintenanceProduct.pid,
          name: maintenanceProduct.name,
          type: maintenanceProduct.type,
          billingcycle: selectedMaintenanceCycle,
          price: oriMaintenancePrice,
          customfield: [],
          customfieldvalue: maintenanceProduct.customfieldvalue,
        })
      );
    } else {
      dispatch(removeCartItem(maintenanceProduct.pid));
    }
  };

  const changeMonitimeCheckbox = (e) => {
    const monitimeProduct = products[1];
    const isChecked = e.target.checked;
    setIsMonitimeChecked(isChecked);

    if (isChecked) {
      // Monitime Trial selalu gratis
      const totalPrice = 0; // Trial is always free
      const configValue = 0; // n-1 formula: 1-1 = 0

      dispatch(
        addToCart({
          gid: monitimeProduct.gid,
          pid: monitimeProduct.pid,
          name: "Monitime (Free Trial 14 Hari)",
          type: monitimeProduct.type,
          billingcycle: "monthly", // Trial selalu menggunakan monthly billing cycle
          price: totalPrice,
          customfield: [],
          customfieldvalue: monitimeProduct.customfieldvalue,
          configoptions: [
            {
              id: 115,
              value: configValue, // n-1 formula
            },
          ],
        })
      );
    } else {
      dispatch(removeCartItem(monitimeProduct.pid));
    }
  };

  const changeMonitimeQuantity = (e) => {
    const inputValue = parseInt(e.target.value);
    const newValue = isNaN(inputValue) || inputValue < 1 ? 1 : inputValue;
    setMonitimeQuantity(newValue);

    // Jika checkbox tercentang, update cart
    if (isMonitimeChecked && newValue > 0) {
      const monitimeProduct = products[1];
      const totalPrice = 0; // Trial is always free
      const configValue = newValue - 1; // n-1 formula

      // Hapus item lama dan tambahkan yang baru
      dispatch(removeCartItem(monitimeProduct.pid));
      dispatch(
        addToCart({
          gid: monitimeProduct.gid,
          pid: monitimeProduct.pid,
          name: "Monitime (Free Trial 14 Hari)",
          type: monitimeProduct.type,
          billingcycle: "monthly", // Trial selalu menggunakan monthly billing cycle
          price: totalPrice,
          customfield: [],
          customfieldvalue: monitimeProduct.customfieldvalue,
          configoptions: [
            {
              id: 115,
              value: configValue, // n-1 formula
            },
          ],
        })
      );
    }
  };

  const changeSslPremiumCheckbox = (e) => {
    const sslProduct = products[2];
    if (e.target.checked && sslPremiumPrice > 0) {
      dispatch(
        addToCart({
          gid: sslProduct.gid,
          pid: sslProduct.pid,
          name: sslProduct.name,
          type: sslProduct.type,
          billingcycle: "annually",
          price: sslPremiumPrice,
          customfield: [],
          customfieldvalue: sslProduct.customfieldvalue,
        })
      );
    } else {
      dispatch(removeCartItem(sslProduct.pid));
    }
  };

  const changeEmailTitanProCheckbox = (e) => {
    const isChecked = e.target.checked;
    setIsEmailTitanChecked(isChecked);

    const emailProduct = products[3];

    // Defensive programming - cek struktur data
    if (!emailProduct || !emailProduct.configoptions || !emailProduct.configoptions.configoption) {
      console.error("Email product structure invalid:", emailProduct);
      notifyWarning("Data produk email tidak valid, silakan refresh halaman");
      return;
    }

    const configOption = emailProduct.configoptions.configoption[0];
    if (!configOption || !configOption.options || !configOption.options.option) {
      console.error("Config option structure invalid:", configOption);
      notifyWarning("Konfigurasi produk email tidak valid, silakan refresh halaman");
      return;
    }

    if (isChecked) {
      // Validasi domain - cek apakah ada domain di cart atau existing domain
      const hasDomainInCart = productsList.some(item =>
        item.type === "register" ||
        item.type === "transfer" ||
        item.type === "domain-existing"
      ) || (existingDomain && existingDomain.domain);

      if (!hasDomainInCart) {
        notifyWarning("Email Titan Pro memerlukan domain. Silakan isi domain terlebih dahulu!");
        setIsEmailTitanChecked(false);
        return;
      }

      // Fixed quantity = 1
      const price = emailTitanProPrice;
      const totalPrice = price; // Fixed quantity = 1

      dispatch(
        addToCart({
          pid: emailProduct.pid,
          name: emailProduct.name,
          billingcycle: selectedEmailCycle,
          duration: selectedEmailCycle,
          price: totalPrice,
          customfield: [],
          customfieldvalue: emailProduct.customfieldvalue,
          configoptions: [
            {
              id: 100,
              value: 1, // Fixed quantity = 1
            },
          ],
          type: "emailSuite",
        })
      );
    } else {
      dispatch(removeCartItem(emailProduct.pid));
    }
  };

  const changeEmailAccount = (e) => {
    const inputValue = parseInt(e.target.value);
    const newValue = isNaN(inputValue) || inputValue < 1 ? 0 : inputValue;
    setEmailAccountValue(newValue);

    // Jika checkbox tercentang, update cart
    if (isEmailTitanChecked && newValue > 0) {
      const emailProduct = products[3];

      // Defensive programming - cek struktur data
      if (!emailProduct || !emailProduct.configoptions || !emailProduct.configoptions.configoption) {
        console.error("Email product structure invalid:", emailProduct);
        notifyWarning("Data produk email tidak valid");
        return;
      }

      const configOption = emailProduct.configoptions.configoption[0];
      if (!configOption || !configOption.options || !configOption.options.option) {
        console.error("Config option structure invalid:", configOption);
        notifyWarning("Konfigurasi produk email tidak valid");
        return;
      }

      const pricingData = configOption.options.option[0].pricing?.IDR;
      if (!pricingData || !pricingData[emailProduct.billingcycle]) {
        console.error("Pricing data not found:", pricingData);
        notifyWarning("Data harga email tidak tersedia");
        return;
      }

      const price = parseInt(pricingData[emailProduct.billingcycle]);
      const totalPrice = price * newValue;

      // Hapus item lama dan tambahkan yang baru
      dispatch(removeCartItem(emailProduct.pid));
      dispatch(
        addToCart({
          pid: emailProduct.pid,
          name: emailProduct.name,
          billingcycle: selectedEmailCycle,
          duration: selectedEmailCycle,
          price: totalPrice,
          customfield: [],
          customfieldvalue: emailProduct.customfieldvalue,
          configoptions: [
            {
              id: 100,
              value: newValue,
            },
          ],
          type: "emailSuite",
        })
      );
    }
  };

  // const changePromoKaosTumbler = (e) => {
  //   const isChecked = e.target.checked;
  //   setPromoKaosTumbler(isChecked);
  //   dispatch(addPromoKaos({ promoKaos: isChecked }));
  // };

  useEffect(() => {
    const removeAllAdditionalProducts = () => {
      if (!products || products.length === 0) return; // Pastikan products tidak null atau kosong

      const productIds = products
        .filter(product => product && product.pid) // Filter hanya produk yang valid
        .map(product => product.pid);

      // Only remove PromoKaosTumbler products, not email suite products
      const promoProductIds = productIds.filter(pid => {
        const cartItem = productsList.find(item => item.pid === pid);
        return cartItem && cartItem.type !== "emailSuite"; // Don't remove email suite products
      });

      promoProductIds.forEach(pid => dispatch(removeCartItem(pid)));

      // Reset semua state checkbox
      setIsMaintenanceChecked(false);
      setIsMonitimeChecked(false);
      setIsEmailTitanChecked(false);
      setEmailAccountValue(0);
      setMonitimeQuantity(1);
    };

    // Only run this effect when billingcycle changes, not when products change
    if (isInitialized.current) {
      removeAllAdditionalProducts();
    }
  }, [billingcycle]); // Remove products and dispatch from dependencies

  const changeMaintenanceCycle = (e) => {
    const newCycle = e.target.value;
    setSelectedMaintenanceCycle(newCycle);

    // Update pricing display menggunakan data yang sudah ada
    const maintenanceProduct = products[0];
    if (maintenanceProduct && maintenanceProduct.pricing[newCycle]) {
      const newPrice = parseFloat(maintenanceProduct.pricing[newCycle]) || 0;
      setMaintenancePrice(newPrice * 1.2);
      setOriMaintenancePrice(newPrice);
    }

    // Jika sudah di-check, update cart
    if (isMaintenanceChecked) {
      const maintenanceProduct = products[0];
      const newPrice = parseFloat(maintenanceProduct.pricing[newCycle]) || 0;
      dispatch(removeCartItem(maintenanceProduct.pid));

      dispatch(
        addToCart({
          gid: maintenanceProduct.gid,
          pid: maintenanceProduct.pid,
          name: maintenanceProduct.name,
          type: maintenanceProduct.type,
          billingcycle: newCycle,
          price: newPrice,
          customfield: [],
          customfieldvalue: maintenanceProduct.customfieldvalue,
        })
      );
    }
  };

  const changeMonitimeCycle = (e) => {
    const newCycle = e.target.value;
    setSelectedMonitimeCycle(newCycle);

    // Monitime Trial selalu gratis dan menggunakan monthly billing cycle
    setMonitimePrice(0);
    setOriMonitimePrice(0);

    // Jika sudah di-check, update cart
    if (isMonitimeChecked) {
      const monitimeProduct = products[1];
      const totalPrice = 0; // Trial is always free
      dispatch(removeCartItem(monitimeProduct.pid));

      dispatch(
        addToCart({
          gid: monitimeProduct.gid,
          pid: monitimeProduct.pid,
          name: "Monitime (Free Trial 14 Hari)",
          type: monitimeProduct.type,
          billingcycle: "monthly", // Trial selalu menggunakan monthly billing cycle
          price: totalPrice,
          customfield: [],
          customfieldvalue: monitimeProduct.customfieldvalue,
          configoptions: [
            {
              id: 115,
              value: monitimeQuantity - 1, // n-1 formula
            },
          ],
        })
      );
    }
  };

  return (
    <>
      {/* {price <= 3000000 && price > 0 && (
        <div className="col-12 mt-4 mb-3">
          <span className="text-qw-primary fw-medium">
            Tambahkan produk lainnya untuk mendapatkan kaos dan tumbler gratis!
          </span>
          <br />
          <span className="text-muted fw-medium">
            Kurang: Rp -{(3000000 - price).toLocaleString("id-ID")} Lagi
          </span>
        </div>
      )}
      {isEligibleForPromo && price > 0 && (
        <div className="col-12 mt-4">
          <span className="text-success fw-semibold">
            Selamat! Anda mendapatkan kaos dan tumbler gratis!
          </span>
        </div>
      )} */}

      {/* <div className="row">
        <div className="col-12 col-lg-8 d-flex align-items-center">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              name="kaos_tumbler"
              id="kaos_tumbler"
              value="kaos_tumbler"
              onChange={changePromoKaosTumbler}
              checked={promoKaosTumbler && isEligibleForPromo}
              disabled={!isEligibleForPromo}
            />
            <label
              htmlFor="kaos_tumbler"
              className="ms-3 form-check-label fw-bold"
              style={{ fontSize: "16px" }}
            >
              Gratis Kaos dan Tumbler (Termasuk Ongkir)
            </label>
          </div>
        </div>
        <div className="col-12 col-lg-4 d-grid justify-content-end align-items-center">
          <p className="fw-bold mb-0 d-inline-block text-secondary">
            <del>Rp150.000</del>
          </p>
          <span className="badge bg-warning p-2">GRATIS!</span>
        </div>
      </div> */}

      {price > 0 && (
        <>
          {/* Offers Product (Optional) Label */}
          <div className="row mt-4 mb-3">
            <div className="col-12 d-flex align-items-center justify-content-center justify-content-md-start">
              <button
                className="btn btn-link fw-bold text-muted p-0 d-flex align-items-center"
                type="button"
                onClick={() => setShowOtherProducts((prev) => !prev)}
                style={{ fontSize: "1.1rem", textDecoration: "none" }}
              >
                Produk Lainnya
                {showOtherProducts ? (
                  <FontAwesomeIcon icon={faChevronUp} className="ms-2" />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
                )}
              </button>
            </div>
          </div>
          {/* offer Product */}
          {showOtherProducts && (
            <>
              {/* Loading State */}
              {isProductsLoading && (
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="d-flex align-items-center">
                      <div className="spinner-border spinner-border-sm me-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="text-muted">Memuat produk...</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Error State */}
              {productsError && (
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="alert alert-warning d-flex align-items-center" role="alert">
                      <div className="me-2">
                        <i className="fas fa-exclamation-triangle"></i>
                      </div>
                      <div>
                        <strong>Peringatan!</strong> {productsError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!isJasaMaintenanceWebsite && (
                <div className="row">
                  <div className="col-12 col-lg-8">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="maintenance_service"
                        id="maintenance_service"
                        value="maintenance_service"
                        checked={isMaintenanceChecked}
                        onChange={changeMaintenanceCheckbox}
                        disabled={isProductsLoading || productsError || maintenancePrice === 0 || oriMaintenancePrice === 0}
                      />
                      <label
                        htmlFor="maintenance_service"
                        className="ms-3 form-check-label fw-bold"
                        style={{ fontSize: "16px" }}
                      >
                        Jasa Maintenance Website
                        <FontAwesomeIcon
                          icon={faExclamationCircle}
                          className="ms-2"
                          style={{ fontSize: "14px", cursor: "pointer", color: "#FF6B35" }}
                          onClick={openMaintenanceModal}
                          title="Jasa Maintenance Website"
                        />
                      </label>
                    </div>
                    <div className="mt-2">
                      <select
                        className="form-select"
                        style={{ maxWidth: "200px" }}
                        value={selectedMaintenanceCycle}
                        onChange={changeMaintenanceCycle}
                        disabled={isProductsLoading || productsError}
                      >
                        <option value="monthly">1 Bulan</option>
                        <option value="quarterly">3 Bulan</option>
                        <option value="semiannually">6 Bulan</option>
                        <option value="annually">1 Tahun</option>
                        <option value="biennially">2 Tahun</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 d-flex flex-column align-items-end mt-3 mt-lg-0">
                    <p className="fw-bold mb-0 text-secondary small">
                      <del>{formatIDR(maintenancePrice)}</del>
                    </p>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-warning p-2 me-2">PROMO</span>
                      <p className="fw-bold mb-0 text-secondary small">
                        {formatIDR(oriMaintenancePrice)}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Hide Monitime Trial section when on orderproduct page with pid 1157 */}
              {!isOrderProductMonitime && (
                <div className="row mt-3">
                  <div className="col-12 col-lg-8">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="monitime_service"
                        id="monitime_service"
                        value="monitime_service"
                        checked={isMonitimeChecked}
                        onChange={changeMonitimeCheckbox}
                        disabled={isProductsLoading || productsError}
                      />
                      <label
                        htmlFor="monitime_service"
                        className="ms-3 form-check-label fw-bold"
                        style={{ fontSize: "16px" }}
                      >
                        Monitime (Free Trial 14 Hari)
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="monitime-tooltip">
                              Aplikasi Monitoring Website - Trial Gratis 14 Hari
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon
                            icon={faExclamationCircle}
                            className="ms-2"
                            style={{ fontSize: "14px", cursor: "help", color: "#FF6B35" }}
                          />
                        </OverlayTrigger>
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 d-flex flex-column align-items-end mt-3 mt-lg-0">
                    <div className="d-flex align-items-center">
                      <span className="badge bg-success p-2 me-2">FREE TRIAL</span>
                      <p className="fw-bold mb-0 text-success small">
                        GRATIS
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="row mt-3">
                <div className="col-12 col-lg-8 d-flex align-items-center">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="ssl_premium"
                      id="ssl_premium"
                      value="ssl_premium"
                      disabled={isProductsLoading || productsError || sslPremiumPrice <= 0}
                      onChange={changeSslPremiumCheckbox}
                    />
                    <label
                      htmlFor="ssl_premium"
                      className="ms-3 form-check-label fw-bold"
                      style={{ fontSize: "16px" }}
                    >
                      TuringSign Basic DV <span className="ms-1">(1 Tahun)</span>
                    </label>
                  </div>
                </div>
                <div className="col-12 col-lg-4 d-flex flex-column align-items-end mt-3 mt-lg-0">
                  {sslPremiumPrice > 0 ? (
                    <>
                      <p className="fw-bold mb-0 text-secondary small">
                        <del>{formatIDR(oriSslPremiumPrice)}</del>
                      </p>
                      <div className="d-flex align-items-center">
                        <span className="badge bg-warning p-2 me-2">PROMO</span>
                        <p className="fw-bold mb-0 text-secondary small">
                          {formatIDR(sslPremiumPrice)}
                        </p>
                      </div>
                    </>
                  ) : (
                    <p className="fw-bold mb-0 text-muted small">
                      Tidak tersedia
                    </p>
                  )}
                </div>
              </div>

              {/* order email suite */}
              {!isOrderEmailSuitePage && (
                <div className="row mt-4">
                  <div className="col-12 col-lg-8">
                    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="email_titan_pro"
                          id="email_titan_pro"
                          value="email_titan_pro"
                          checked={isEmailTitanChecked}
                          onChange={changeEmailTitanProCheckbox}
                          disabled={isProductsLoading || productsError}
                        />
                        <label
                          htmlFor="email_titan_pro"
                          className="ms-3 form-check-label fw-bold"
                          style={{ fontSize: "16px" }}
                        >
                          Email Titan Pro
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="email-titan-tooltip">
                                Harga untuk per Email Account/Inbox
                                {cartDomain && (
                                  <div className="mt-1">
                                    <strong>Domain:</strong> {cartDomain}
                                  </div>
                                )}
                              </Tooltip>
                            }
                          >
                            <FontAwesomeIcon
                              icon={faExclamationCircle}
                              className="ms-2"
                              style={{ fontSize: "14px", cursor: "help", color: "#FF6B35" }}
                            />
                          </OverlayTrigger>
                        </label>
                      </div>
                      <div className="ms-0 ms-md-4 mt-2 mt-md-0 d-flex align-items-center">
                        <label
                          htmlFor="emailAccount"
                          className="form-label mb-0 me-2"
                        >
                          Jumlah Akun
                        </label>
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          id="emailAccount"
                          style={{ maxWidth: "80px" }}
                          value={1}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      <select
                        className="form-select"
                        style={{ maxWidth: "200px" }}
                        value={selectedEmailCycle}
                        disabled={isProductsLoading || productsError}
                        onChange={(e) => {
                          const newCycle = e.target.value;
                          setSelectedEmailCycle(newCycle);

                          // Update cart jika Email Titan Pro sudah tercentang
                          if (isEmailTitanChecked) {
                            // Validasi domain - cek apakah ada domain di cart atau existing domain
                            const hasDomainInCart = productsList.some(item =>
                              item.type === "register" ||
                              item.type === "transfer" ||
                              item.type === "domain-existing"
                            ) || (existingDomain && existingDomain.domain);

                            if (!hasDomainInCart) {
                              notifyWarning("Email Titan Pro memerlukan domain. Silakan pilih domain terlebih dahulu!");
                              return;
                            }

                            const emailProduct = products[3];
                            if (emailProduct && emailProduct.configoptions?.configoption[0]?.options?.option[0]?.pricing?.IDR) {
                              const pricingIDR = emailProduct.configoptions.configoption[0].options.option[0].pricing.IDR;
                              const newPrice = parseFloat(pricingIDR[newCycle]) || 0;

                              // Update pricing state untuk konsistensi
                              setEmailTitanProPrice(newPrice);
                              setOriEmailTitanProPrice(newPrice * 1.1);

                              // Hapus item lama dan tambahkan yang baru
                              dispatch(removeCartItem(emailProduct.pid));
                              dispatch(
                                addToCart({
                                  pid: emailProduct.pid,
                                  name: emailProduct.name,
                                  billingcycle: newCycle,
                                  duration: newCycle,
                                  price: newPrice,
                                  customfield: [],
                                  customfieldvalue: emailProduct.customfieldvalue,
                                  configoptions: [
                                    {
                                      id: 100,
                                      value: 1, // Fixed quantity = 1
                                    },
                                  ],
                                  type: "emailSuite",
                                })
                              );
                            }
                          }
                        }}
                      >
                        <option value="monthly">1 Bulan</option>
                        <option value="annually">1 Tahun</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 d-flex flex-column align-items-end mt-3 mt-lg-0">
                    {emailTitanProPrice > 0 ? (
                      <>
                        <p className="fw-bold mb-0 text-secondary small">
                          <del>{formatIDR(oriEmailTitanProPrice)}</del>
                        </p>
                        <div className="d-flex align-items-center">
                          <span className="badge bg-warning p-2 me-2">PROMO</span>
                          <p className="fw-bold mb-0 text-secondary small">
                            {formatIDR(emailTitanProPrice)}
                          </p>
                        </div>
                      </>
                    ) : (
                      <p className="fw-bold mb-0 text-secondary small">
                        {formatIDR(286800)}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      {/* Modal for Maintenance Information */}
      <Modal
        show={showMaintenanceModal}
        onHide={closeMaintenanceModal}
        centered
        id="maintenanceInfoModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Jasa Maintenance Website</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>Website Management</li>
            <li>Wordpress Management</li>
            <li>Article Update</li>
            <li>Uptime Monitoring</li>
            <li>Tweak Performance</li>
            <li>Backup Services</li>
          </ul>
          <p className="text-muted">
            <small>by 5mnt.com</small>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PromoKaosTumbler;
